import React, { useContext, useState, useEffect } from 'react';
import '../../App.css'
import { Button, Container, List, Typography } from '@mui/material';
import Layout from '../../component/Layout';
import { UserProfile } from '../../contexts/UserContext';
import { SystemProfile } from '../../contexts/SystemContext';
import TextField from '@mui/material/TextField';
import api from '../../connection/Axios';
import InputMask from 'react-input-mask';
import apiCep from '../../utilities/Cep';


const AdicionarEmpresa = () => {
  const [userData, setUserData] = useContext(UserProfile)
  const [systemData, setSystemData] = useContext(SystemProfile)

  const [nomeFantasia, setNomeFantasia] = useState('')
  const [cnpj, setCnpj] = useState('')
  const [userAdministrador, setUserAdministrador] = useState('')
  const [equipe, setEquipe] = useState([])
  const dataCriacao = new Date()
  const [adminOk, setAdminOk] = useState(false)
  const [rua, setRua] = useState('')
  const [numero, setNumero] = useState('')
  const [compl, setCompl] = useState('')
  const [bairro, setBairro] = useState('')
  const [cep, setCEP] = useState('')
  const [cidade, setCidade] = useState('')
  const [uf, setUF] = useState('')
  const [telefone, setTelefone] = useState('')
  const [conclusao, setConclusao] = useState(false)
  

      async function BuscaCep() {
    try {
        const newCep = cep.replace(/-/g, '');
        const response = await apiCep.get(`/${newCep}/json/`)
        setRua(response.data.logradouro)
        setBairro(response.data.bairro)
        setCidade(response.data.localidade)
        setUF(response.data.uf)
    }catch(error){
        console.log('error: +'+error)
    }
}

    useEffect(()=>{
        if(cep.length >= 7){
            BuscaCep()
        }
    }, [cep])


  const data = {
	  "cnpj": cnpj,
    "nomeFantasia": nomeFantasia,
    "rua": rua, 
    "numero": numero, 
    "compl": compl, 
    "bairro": bairro, 
    "cidade": cidade, 
    "uf": uf, 
    "cep": cep,
    "telefone": telefone, 
    "dataCriacao": dataCriacao
}

  function ValidateEmail() {
    var re = /\S+@\S+\.\S+/;
    if (re.test(userAdministrador) === true) {
        SaveEmpresa()
    } else {
        setSystemData({...systemData, erro : 'Digite um email válido', typeError : 'error'})
    }
  }

  const headers = {
    headers: {
      "Content-Type": "application/json", "Access-Control-Allow-Origin": "*",
      "Authorization": `Bearer ${userData.token}`
    }};


  async function SaveEmpresa() {
    await api.post('company/createCompany/', data, headers).then(response => {
      console.log(JSON.stringify(response.data))
      setConclusao(true)
    }).catch(error => {
      setSystemData({...systemData, erro: error.message, typeError: 'warning'})
    })
  }
  
  return (
    <>
        <Layout breadcrumb='Dashboard / Empresas / Adicionar empresa' title='Adicionar Empresa'>
          <Typography>Preencha os campos abaixo para adicionar uma nova empresa:</Typography>
          {conclusao ? 
            <>
              <div style={styles.block}></div>
              <div style={styles.block}></div>
              <span style={{fontWeight: 600, fontSize: 14, color: '#ff6400'}}>Empresa {nomeFantasia} salva com sucesso!</span>
              <div style={styles.block}></div>
              <div style={styles.block}></div>
            </>
:
          
          <>
            <div style={styles.block}></div>
            <TextField  onChange={(event) => setNomeFantasia(event.target.value)} value={nomeFantasia} label="Nome Fantasia" variant="outlined" style={styles.item} />
            <div>
            <InputMask
                mask="99999-999"
                value={cep}
                onChange={(event) => setCEP(event.target.value)}
                disabled={false}
                maskChar=" "
            >
                {() => <TextField label="CEP *" variant="outlined" style={styles.itemPeq} />}
            </InputMask>

            <InputMask
                mask="99.999.999/9999-99"
                value={cnpj}
                onChange={(event) => setCnpj(event.target.value)}
                disabled={false}
                maskChar=" "
            >

                {() => <TextField label="CNPJ *" variant="outlined" style={styles.itemMed} />}
            </InputMask>
            </div>
            <div>
              <TextField  onChange={(event) => setRua(event.target.value)} value={rua} label="Logradouro *" variant="outlined" style={styles.itemMed} />
              <TextField  onChange={(event) => setNumero(event.target.value)} value={numero} label="Num. *" variant="outlined" style={styles.itemPeq} />
              <TextField  onChange={(event) => setCompl(event.target.value)} value={compl} label="Compl." variant="outlined" style={styles.itemPeq} />
            </div>
            <div>
              <TextField  onChange={(event) => setBairro(event.target.value)} value={bairro} label="Bairro *" variant="outlined" style={styles.itemMed} />
              
              
              <InputMask
                  mask="(99) 99999-9999"
                  value={telefone}
                  onChange={(event) => setTelefone(event.target.value)}
                  disabled={false}
                  maskChar=" "
              >
                  {() => <TextField label="Telefone *" variant="outlined" style={styles.itemPeq} />}
              </InputMask>
            </div>
            <div>
              <TextField  onChange={(event) => setCidade(event.target.value)} value={cidade} label="Cidade *" variant="outlined" style={styles.itemMed} />
              <TextField  onChange={(event) => setUF(event.target.value)} value={uf} label="UF *" variant="outlined" style={styles.itemPeq} />
            </div>
            
            {adminOk ? null :
              <div style={styles.block}>
                <Button variant="contained" color='secondary' className='boto' style={{color: '#ffffff'}} onClick={()=>{SaveEmpresa()}}>
                  Salvar empresa
                </Button>
              </div>
            }
            

            <div style={styles.block}></div>
            <div style={styles.block}></div>
            {adminOk ?
            <>

              {conclusao ? null :
              <div style={styles.blockFinal}>
                <Button variant="contained" className='boto' style={{color: '#ffffff', paddingBlock: 12}} onClick={()=>{ValidateEmail()}}>
                  Finalizar Cadastro
                </Button>
              </div>
              }
            </>
            : null}
          </>
}          
        </Layout>
    </>
  );
};

export default AdicionarEmpresa


const styles = {
  block: {
    marginTop: 10,
  },
  blockFinal: {
    marginTop: 10,
    display: 'flex',
    justifyContent: 'center',
  },
    item: {
        marginTop: 5,
        marginLeft: 5,
        marginRight: 5,
        marginBottom: 5,
        width: '100%'
    },
    itemPeq: {
        width: 100,
        marginTop: 5,
        marginLeft: 5,
        marginRight: 5,
        marginBottom: 5,
    },
    itemMed: {
        width: 400,
        marginTop: 5,
        marginLeft: 5,
        marginRight: 5,
        marginBottom: 5,
    }
}
